// Zugriff auf die DB-Portal-API (/api/db-portal/*). Fehler kommen als ApiFehler mit Code und
// deutscher Meldung; nicht angemeldet (401) und Vertraulichkeit offen (403) werden vom Rahmen behandelt.
export const API_BASIS = '/api/db-portal';

export class ApiFehler extends Error {
  constructor(
    public status: number,
    public code: string,
    meldung: string,
  ) {
    super(meldung);
    this.name = 'ApiFehler';
  }
}

interface Optionen {
  methode?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  json?: unknown;
  text?: string;
  /** zum Abbrechen veralteter Anfragen */
  signal?: AbortSignal;
}

export async function api<T>(pfad: string, o: Optionen = {}): Promise<T> {
  const kopf: Record<string, string> = { accept: 'application/json' };
  let body: string | undefined;
  if (o.text !== undefined) {
    kopf['content-type'] = 'text/csv; charset=utf-8';
    body = o.text;
  } else if (o.json !== undefined) {
    kopf['content-type'] = 'application/json';
    body = JSON.stringify(o.json);
  }
  let antwort: Response;
  try {
    antwort = await fetch(API_BASIS + pfad, { method: o.methode ?? 'GET', headers: kopf, body: body ?? null, credentials: 'same-origin', signal: o.signal ?? null });
  } catch {
    if (o.signal?.aborted) throw new ApiFehler(0, 'abgebrochen', 'Anfrage abgebrochen.');
    throw new ApiFehler(0, 'netzwerk', 'Keine Verbindung zum Server. Bitte Verbindung prüfen und erneut versuchen.');
  }
  const text = await antwort.text();
  let daten: unknown = null;
  try {
    daten = text ? JSON.parse(text) : null;
  } catch {
    daten = null;
  }
  if (!antwort.ok) {
    const f = (daten ?? {}) as { fehler?: string; meldung?: string };
    throw new ApiFehler(
      antwort.status,
      f.fehler ?? 'unbekannt',
      f.meldung ?? (antwort.status === 429 ? 'Zu viele Anfragen – bitte später erneut versuchen.' : 'Es ist ein Fehler aufgetreten.'),
    );
  }
  return daten as T;
}
